<div class="page-wrapper">
  <!-- Decorative corner -->
  <svg
    class="deco-corner"
    viewBox="0 0 300 280"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <line x1="300" y1="0" x2="0" y2="280" stroke="rgba(14,116,144,.08)" stroke-width="1" />
    <line x1="300" y1="60" x2="60" y2="280" stroke="rgba(14,116,144,.06)" stroke-width="1" />
    <line x1="300" y1="120" x2="120" y2="280" stroke="rgba(14,116,144,.05)" stroke-width="1" />
    <path
      d="M300 280 L300 80 Q300 20 240 20 L160 20 Q80 20 40 100 Q0 180 0 280 Z"
      fill="url(#cornerGrad)"
      opacity=".9"
    />
    <defs>
      <linearGradient id="cornerGrad" x1="300" y1="0" x2="0" y2="280" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stop-color="#0e7490" />
        <stop offset="55%" stop-color="#1d4ed8" />
        <stop offset="100%" stop-color="#7c3aed" stop-opacity=".7" />
      </linearGradient>
    </defs>
  </svg>

  <div class="page-container">
    <!-- TOPBAR -->
    <header class="topbar">
      <div class="hero-logo">
        <img src="../../assets/images/Logo.svg" alt="Nishwik Logo" class="img-fluid" />
      </div>
    </header>

    <!-- MAIN CONTENT -->
    <main class="main-content">
      <!-- LEFT PANEL -->
      <section class="left-panel">
        <div class="school-badge">
          <span class="school-badge-dot"></span>
          School Management Platform
        </div>

        <h1 class="headline">
          Smart School.<br />
          <em>Smarter Future.</em>
        </h1>

        <p class="subtext">
          Manage student admissions, attendance, timetables, fee collections,
          exam results, and teacher workflows — all from one unified platform
          built for modern schools.
        </p>

        <div class="feature-grid">
          <div class="feature-card">
            <div class="fc-icon cyan">
              <i class="fas fa-user-graduate"></i>
            </div>
            <div class="fc-text">
              <strong>Admissions</strong>
              <span>Enrolment & bulk uploads</span>
            </div>
          </div>
          <div class="feature-card">
            <div class="fc-icon blue">
              <i class="fas fa-clipboard-check"></i>
            </div>
            <div class="fc-text">
              <strong>Attendance</strong>
              <span>Daily & subject tracking</span>
            </div>
          </div>
          <div class="feature-card">
            <div class="fc-icon violet">
              <i class="fas fa-rupee-sign"></i>
            </div>
            <div class="fc-text">
              <strong>Fee Management</strong>
              <span>Payments & notifications</span>
            </div>
          </div>
          <div class="feature-card">
            <div class="fc-icon amber">
              <i class="fas fa-chart-bar"></i>
            </div>
            <div class="fc-text">
              <strong>Exams & Results</strong>
              <span>Marksheets & reports</span>
            </div>
          </div>
        </div>
      </section>

      <!-- RIGHT PANEL -->
      <section class="right-panel">
        <div class="login-card">
          <h2 class="card-title">Welcome Back</h2>

          <!-- PASSWORD LOGIN -->
          <form *ngIf="!isMobileLogin" [formGroup]="loginForm" (ngSubmit)="onLogin()">
            <div class="form-group">
              <label class="form-label">Username / Email</label>
              <input
                type="text"
                class="form-control"
                placeholder="Enter username"
                formControlName="username"
                [class.error]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
              />
            </div>

            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label class="form-label">Password</label>
              </div>
              <div class="password-wrap">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  class="form-control"
                  placeholder="Enter password"
                  formControlName="password"
                  [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                />
                <button type="button" class="pwd-toggle" (click)="togglePassword()">
                  <i class="fas" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
                </button>
              </div>
            </div>

            <div class="form-meta">
              <label class="remember-label">
                <input type="checkbox" /> Remember me
              </label>
            </div>

            <button
              type="submit"
              class="btn-primary"
              [disabled]="loginForm.invalid || loading"
              [class.loading]="loading"
            >
              <span class="btn-text">Sign In</span>
            </button>
          </form>

          <!-- MOBILE LOGIN -->
          <form *ngIf="isMobileLogin && !isOtpSent" [formGroup]="mobileForm" (ngSubmit)="sendOtp()">
            <div class="form-group">
              <label class="form-label">Mobile Number</label>
              <input
                type="tel"
                class="form-control"
                placeholder="Enter 10-digit number"
                formControlName="mobileNo"
                [class.error]="mobileForm.get('mobileNo')?.invalid && mobileForm.get('mobileNo')?.touched"
              />
            </div>
            <button
              type="submit"
              class="btn-primary"
              [disabled]="mobileForm.invalid || loading"
              [class.loading]="loading"
            >
              <span class="btn-text">Send OTP</span>
            </button>
          </form>

          <!-- OTP VERIFICATION -->
          <div *ngIf="isOtpSent" class="otp-section">
            <p class="text-success text-center mb-3 small">{{ maskedMessage }}</p>
            <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
              <div class="otp-boxes mb-4">
                <input id="otp1" maxlength="1" class="otp-input" formControlName="otp1" (input)="onOtpInput($event, 1)" />
                <input id="otp2" maxlength="1" class="otp-input" formControlName="otp2" (input)="onOtpInput($event, 2)" />
                <input id="otp3" maxlength="1" class="otp-input" formControlName="otp3" (input)="onOtpInput($event, 3)" />
                <input id="otp4" maxlength="1" class="otp-input" formControlName="otp4" (input)="onOtpInput($event, 4)" />
                <input id="otp5" maxlength="1" class="otp-input" formControlName="otp5" (input)="onOtpInput($event, 5)" />
                <input id="otp6" maxlength="1" class="otp-input" formControlName="otp6" (input)="onOtpInput($event, 6)" />
              </div>

              <div class="d-flex justify-content-between align-items-center mb-4">
                <span class="timer" *ngIf="timerSeconds > 0">{{ timerSeconds }}s remaining</span>
                <a
                  class="resend-link"
                  [class.disabled]="resendOtpDisabled"
                  (click)="!resendOtpDisabled && resendOtp()"
                >Resend OTP</a>
              </div>

              <button
                type="submit"
                class="btn-primary"
                [disabled]="otpForm.invalid || loading"
                [class.loading]="loading"
              >
                <span class="btn-text">Verify & Login</span>
              </button>

              <div class="text-center mt-3">
                <a class="change-no" (click)="changeMobileNo()">Change Mobile Number</a>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>

    <!-- FOOTER -->
    <footer class="bottom-bar">
      <p>&copy; 2026 Nishwik School OS. All rights reserved.</p>
      <div class="bottom-links">
        <a routerLink="/policy/privacy">Privacy Policy</a>
        <a routerLink="/policy/terms">Terms & Conditions</a>
        <a routerLink="/policy/cancellation">Cancellation Policy</a>
        <a routerLink="/policy/refund">Refund Policy</a>
        <a routerLink="/policy/contact">Contact us</a>
      </div>
    </footer>
  </div>
</div>